import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
export const VaultColoredDot = t0 => {
  const $ = _c(3);
  const {
    color
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      padding: "4px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = color || "transparent";
  let t3;
  if ($[1] !== t2) {
    t3 = <Box sx={t1}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill={t2} /></svg></Box>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};